namespace GeniuzPOS.Member {
    export interface PsMemberTypeRow {
        Id?: number;
        MemberType?: string;
        MemberTypeDesc?: string;
        MbPriceFg?: number;
        MbDiscPs?: number;
        SellUnitPriceNo?: PsMemberTypeSelectSellingPrice;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsMemberTypeRow {
        export const idProperty = 'MemberType';
        export const nameProperty = 'MemberTypeDesc';
        export const localTextPrefix = 'Member.PsMemberType';
        export const lookupKey = 'Member.PsMemberType';

        export function getLookup(): Q.Lookup<PsMemberTypeRow> {
            return Q.getLookup<PsMemberTypeRow>('Member.PsMemberType');
        }
        export const deletePermission = '3Member:สมาชิก:Delete';
        export const insertPermission = '3Member:สมาชิก:Modify';
        export const readPermission = '3Member:สมาชิก:View';
        export const updatePermission = '3Member:สมาชิก:Modify';

        export declare const enum Fields {
            Id = "Id",
            MemberType = "MemberType",
            MemberTypeDesc = "MemberTypeDesc",
            MbPriceFg = "MbPriceFg",
            MbDiscPs = "MbDiscPs",
            SellUnitPriceNo = "SellUnitPriceNo",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
